// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "/" + chunkId + "." + "2a40aae3ab4769a91188" + ".css";
};